/*
 These class names are used to provide a means for style overrides by a third party stylesheet.
 Consider this an overview of stylable elements and a way to ensure these class names don't accidentally change or get
 deleted since they have external stylesheets relying on them. This should not replace theming but should provide more
 detailed control over the styles of some elements, mainly the search box iframe version that gets integrated into
 external websites.
 */

export const CLASS_PLANNER_MONTH = 'ext-planner__month';
export const CLASS_PLANNER_WEEK = 'ext-planner__week';
export const CLASS_PLANNER_DAY = 'ext-planner__day';
export const CLASS_PLANNER_CONTAINER = 'ext-planner__day__container';
export const CLASS_PLANNER_DAY_SELECTED = 'ext-planner__day-selected';
export const CLASS_PLANNER_DAY_BLOCKED = 'ext-planner__day-blocked';
export const CLASS_PLANNER_DAY_SELECTED_START = 'ext-planner__day-selected-start';
export const CLASS_PLANNER_DAY_SELECTED_END = 'ext-planner__day-selected-end';
export const CLASS_PLANNER_DAY_WITHIN = 'ext-planner__day-within';
export const CLASS_PLANNER_DAY_BOOKABLE = 'ext-planner__day-bookable';
export const CLASS_PLANNER_DAY_BOOKABLE_WITHIN = 'ext-planner__day-bookable-within';
export const CLASS_PLANNER_DAY_BOOKABLE_OUTSIDE = 'ext-planner__day-bookable-outside';
